import LoginFormMFA from "../../components/Forms/LoginFormMFA";

const LoginMFA = () => {
  return <LoginFormMFA />;
};

export default LoginMFA;
